// MWA-251 — create-time status options. "Pending Client Decision" sends NO status, which
// is what awaiting the client's decision now means: the client has not decided,
// so the application has no position in the pipeline to claim. The rest let
// staff log an already-progressed application directly (Josh: "put it straight
// into Applied").
//
// Mirrors JOB_STATUSES (the client's own Momentum Maximizer Status dropdown)
// minus "Interviewing" and "Got the Job": a job at either needs an interview
// created alongside it, which create-job-opportunity has nothing to build from
// and so rejects with a 400. To log an application that already reached one of
// those, add it at an earlier status and move it into Interviewing, or use
// "Import history" (which does create the interview for a pasted row).
//
// The empty value is deliberate and is not a "pick one" placeholder — it is the
// default and the most common choice.
//
// MWA-367 — shared with the portal's add dialog so a client-added opportunity
// is sourced the same way a staff-added one is. `clientLabel` is the wording the
// client sees where the staff label speaks about the client in the third person.
export interface AddStatusOption {
  value: '' | 'applied' | 'following_up' | 'rejected' | 'closed_not_accepting'
  label: string
  clientLabel?: string
}

export const ADD_STATUS_OPTIONS: readonly AddStatusOption[] = [
  { value: '', label: 'Pending Client Decision', clientLabel: "Opportunity (I haven't decided yet)" },
  { value: 'applied', label: 'Applied' },
  { value: 'following_up', label: 'Following up' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'closed_not_accepting', label: 'Closed/Not Accepting Anymore' },
]

// MWA-392 — the "Date Applied" field only means something once an application
// has been submitted. A job left on "Pending Client Decision" (the empty value)
// has had nothing submitted: it gets its date when it moves into Applied.
export function showsAppliedDate(status: string): boolean {
  return status !== ''
}
